"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useIsFullyVisible;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var isElementFullyVisible = function isElementFullyVisible(element) {
  var elementRect = element.getBoundingClientRect();
  var parentRect = element.parentElement.getBoundingClientRect();
  return elementRect.top >= parentRect.top && elementRect.bottom <= parentRect.bottom && elementRect.left >= parentRect.left && elementRect.right <= parentRect.right;
};
function useIsFullyVisible() {
  var deps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    fullyVisible = _useState2[0],
    setFullyVisible = _useState2[1];
  var ref = (0, _react.useRef)();
  (0, _react.useLayoutEffect)(function () {
    if (ref.current) {
      setFullyVisible(isElementFullyVisible(ref.current));
    } else {
      setFullyVisible(false);
    }
  }, deps);
  return [fullyVisible, ref];
}